import { noop } from 'lodash'
import React from 'react'
import { FormattedMessage } from 'react-intl'
import { createTask } from '../../../../crud/integration.crud'
import { monitorTask, TASK_RUNNER_FAILED } from '../../../../util/tasks.util'
import states from '../states.json'

// Handle the task creation
export function triggerTask(intl, payload, setState = noop, setStatus = noop, monitorTaskLimit) {
  const { customerId, integrationApplicationId, payloadAction: task, userId, errorMappings, parameters } = payload

  // eslint-disable-next-line no-console
  console.log('Triggering task payload', payload)
  // eslint-disable-next-line no-async-promise-executor
  return new Promise(async (resolve) => {
    // Run the create logic
    try {
      const createTaskResponse = await createTask(customerId, integrationApplicationId, task, userId, parameters)
      const { data } = createTaskResponse

      // If the task creation created an error
      if (data.errorMessage) {
        // Fire off the error
        throw new Error(data.errorMessage)
      } else {
        // Watch the task until its completed
        const { result, error } = await monitorTask(customerId, data.taskId, monitorTaskLimit)

        // Handle the error as needed via errorMappings, setState, intl
        if (error && error.isErrorCode) {
          if (error.StatusMessage === TASK_RUNNER_FAILED) {
            setState(states.ERROR)
          }
          // eslint-disable-next-line no-use-before-define
          error.StatusMessage = translateMessage(error.StatusMessage, errorMappings, intl)
        }

        // Task is completed, return result
        resolve({ error, result })
      }
    } catch (e) {
      console.error(e.message)
      // eslint-disable-next-line no-use-before-define
      setStatus(defaultError())

      // Unexpected error
      resolve({ error: e.message })
    }
  })
}

// Default error to display
const defaultError = () => (
  <>
    <FormattedMessage id="GENERAL.ERROR" />
    <a href="https://support.augmentt.com" target="_blank" rel="noopener noreferrer">
      <FormattedMessage id="GENERAL.CONTACT_SUPPORT" />
    </a>
  </>
)

// Takes the error code and translates it into the error message
const translateMessage = (errorCode, errorMappings, intl) => {
  // Translate the error code into a specified message depending on the action
  // eslint-disable-next-line no-use-before-define
  const overwrittenMappings = Object.assign(genericMapping, errorMappings)
  const mappedId = overwrittenMappings[errorCode]

  if (mappedId) {
    const translatedMessage = intl.formatMessage({ id: mappedId })

    // Error code was found
    if (translatedMessage) {
      return translatedMessage
    }
  }

  // Return a generic default error if we get here
  return intl.formatMessage({ id: 'GENERAL.ERROR' })
}

// Mapping of errorCode to en.json key
const genericMapping = {
  NOT_FOUND: 'GENERIC_NOT_FOUND',
  MISSING_PARAMETER: 'GENERIC_MISSING_PARAMETER',
  FAILED_VALIDATION: 'GENERIC_FAILED_VALIDATION',
  FAILED_SEND: 'GENERIC_FAILED_SEND',
  EXECUTION_FAILED: 'GENERIC_EXECUTION_FAILED',
  ALREADY_EXISTS: 'GENERIC_ALREADY_EXISTS',
  PARTLY_COMPLETED: 'GENERIC_PARTLY_COMPLETED',
  MISSING_TANGIBLES: 'GENERIC_MISSING_TANGIBLES',
  FAILURE: 'GENERAL.CONTACT_SUPPORT',
  INVALID_AUTHENTICATION_TOKEN: 'GENERAL.INVALID_AUTHENTICATION_TOKEN', // TODO
}
